import React from "react";
import NavigationBar from "../../../components/Navigationbar/Navigationbar";
import "./Vereinallgemein.css";
import { useState } from "react";
import { post, Token, url } from "../../../Script/Session";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AddButton from "../../../components/buttons/createButton/CreateButton";
import Deletebutton from "../../../components/buttons/deletebutton/Deletebutton";
import { haspermission } from "../../../Script/Permission";
import Sidebar from "../../../components/Sidebar/Sidebar";
import Editfield from "./Editfield";
import Stylebutton from "../../../components/buttons/stylebutton/Stylebutton";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { Typography } from "@mui/joy";
const Veranstatungallgemein = () => {


  const [wit, setwith] = useState("90.5%");


  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const selectedFile = document.getElementById("file-input-logo").files[0];
    setFile(selectedFile);
    sendPostRequest();
  };
  function sendPostRequest() {
    const formData = new FormData();

    const jsonData = {
      token: Token.get(),
    };
    formData.append('data', JSON.stringify(jsonData));

    const imageFile = document.getElementById("file-input-logo").files[0];
    formData.append('file', imageFile);

    fetch(url + '/api/logo', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.text())
      .then(text => {
        console.log(text);
        if (text === "NOPERMS") {
          alert("Keine Berechtigung");
        } else if (text === "INVALIDFILE") {
          alert("Die Datei muss eine .ico-Datei sein");
        } else {
          window.location.reload();
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });

  }

  const [data, setData] = useState([]);
  const [canEditpage, seteditpage] = useState(haspermission("17"));
  const [caneditlogo, setcaneditlogo] = useState(haspermission("16"))

  function addfiled(k, v) {
    if (!haspermission("16")) {
      alert("Keine Berechtigung");
    }
    if (k == "name") {
      return;
    }
    if (data.fields.some(item => item.key == k)) {
      alert("Feldname existiert bereits");
      return;
    }
    let body = {
      token: Token.get(),
      action: "createfield",
      target: k,
      value: v,
    }
    let response = post(body, "/verein");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response == "OK") {
      let json = data;
      json.fields.push({ key: k, value: v });
      setData(json);

    } else {
      alert("fehler");
      console.log(response);
    }


  }
  function removefield(t) {
    if (!haspermission("16")) {
      alert("Keine Berechtigung");
    }
    let body = {
      token: Token.get(),
      action: "deletefield",
      target: t,
    }
    if (t == "Vereinsname") {
      alert("Dieses Feld kann nicht bearbeitet werden");
      return;
    }
    let response = post(body, "/verein");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response == "OK") {
      load()
    } else {
      alert("fehler");
      console.log(response);
    }

  }

  function load() {
    const body = {
      token: Token.get(),
      action: "get",
    };

    try {
      let response = post(body, "/verein");

      if (response === "LOGOUT") {
        navigate("/");
        return;
      }

      setData(JSON.parse(response));
      console.log(response);
      setfilterdata(JSON.parse(response).fields);
      setvereinsname(data.Vereinsname);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }


  useEffect(() => {
    const fetchVereinData = async () => {
      const body = {
        token: Token.get(),
        action: "get",
      };

      try {
        let response = await post(body, "/verein");

        if (response === "LOGOUT") {
          navigate("/");
          return;
        }

        setData(JSON.parse(response));
        console.log(response);
        setfilterdata(JSON.parse(response).fields);
        setvereinsname(data.Vereinsname);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchVereinData();
  }, [navigate]);

  function editname(name) {
    let body = {
      token: Token.get(),
      action: "editname",
      target: name,
    }
    let response = post(body, "/verein");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response == "OK") {
      window.location.reload();
    } else {
      alert("fehler");
      console.log(response);
    }

  };
  function sub(e) {
    e.preventDefault();
  }
  const [reglist, setreglist] = useState();
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    let response = post(body, "/regionalgruppen");
    console.log("DEBUG", response);
    setreglist(JSON.parse(response).result);
  }, []);
  const [edit, setedit] = useState(false);
  const [filterdata, setfilterdata] = useState(null);
  const [vereinsname, setvereinsname] = useState(null);
  const [createform, setcreateform] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [current, setcurrent] = useState(null);

  const handleClick = (e) => {
    setTimeout(() => {
      console.log(e.clientX + " " + e.clientY);
      setMousePos({ x: "70%", y: e.clientY });
      setIsOpen(true);
      console.log("set open true");
    }, 5);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      if (isOpen) {
        console.log("set outside false");
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);
  return (
    <>
      <head><title>Verein || Allgemein</title></head>
      <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", backgroundColor: "#eeeeee", height: "100vh", display: "flex", alignItems: "center" }}>
        <ul style={{ width: "100%", height: "100%", overflowY: "auto", overflowX: "hidden", listStyle: "none", }}>
          <div style={{
            display: "flex",
            backgroundColor: "white",
            height: "35%",
            width: "99%",
            marginTop: "0.1%",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "15px"
          }}>
            <div style={{ backgroundColor: "transparent", width: "100%", height: "15%", alignItems: "center", color: "gray", fontSize: "16px", flexDirection: "row", display: "flex" }}>
              <img src={url + "/logo"} alt="Logo" style={{ width: "2.5%", height: "80%", marginLeft: "2.5%" }} />
              <h1 style={{ marginLeft: "1%" }}>{data.Vereinsname}</h1>
              {
                canEditpage && (
                  <div onClick={() => navigate("/page-history/" + "verein-allgemein")} style={{ position: "fixed", right: "10%" }}><Stylebutton buttonText={"SeitenHistorie"} /></div>
                )
              }
              {
                caneditlogo && (
                  <>
                    <div style={{ position: "fixed", right: "1.5%" }} onClick={() => document.getElementById("file-input-logo").click()}><Stylebutton buttonText={"Logo Bearbeiten"} /></div>
                    <input
                      id="file-input-logo"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".ico"
                    />
                  </>


                )
              }


            </div>
            <div style={{ width: "98%", height: "1px", backgroundColor: "gray" }}></div>
            <div style={{ backgroundColor: "transparent", width: "98%", height: "70%", display: "flex", marginTop: "1.0%" }}>
              <div style={{ marginLeft: "1.6%", color: "gray", backgroundColor: "transparent", width: "30%", flexDirection: "column" }}>
                <p>Vereinsname: {data.Vereinsname}</p>
                <p>Aktive Nutzer: {data.aktiveusers}</p>
                <p>Regionalgruppen: {reglist?.length}</p>
                <p>Funktionäre: {data.funktionäre}</p>
                <p>VereinsFelder: {!data.fields ? "Laden" : data.fields.length}</p>
              </div>

            </div>
          </div>



          <div style={{ flexDirection: "row", display: "flex", height: "70%", backgroundColor: "transparent", width: "100%" }}>
            <div style={{
              display: "flex",
              backgroundColor: "white",
              height: "90%",
              width: "45%",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "15px",
              borderRadius: "15px",
              marginLeft: "0.1%"
            }}>
              <div style={{ backgroundColor: "transparent", width: "100%", height: "15%", alignItems: "center", color: "gray", fontSize: "16px", flexDirection: "row", display: "flex" }}>
                <h1 style={{ marginLeft: "2.5%" }}>Zusatzinformationen</h1>
                {
                  caneditlogo && (
                    <div style={{ marginLeft: "42.5%" }} onClick={() => setedit(true)}><Stylebutton buttonText={"Bearbeiten"}></Stylebutton></div>
                  )
                }
              </div>
              <div style={{ width: "98%", height: "1px", backgroundColor: "gray" }}></div>
              <div style={{ backgroundColor: "transparent", width: "98%", height: "800%", display: "flex", marginTop: "1.0%" }}>
                <div style={{ marginLeft: "1.6%", color: "gray", backgroundColor: "transparent", width: "100%", flexDirection: "column" }}>
                  <div style={{ width: "100%", height: "100%", backgroundColor: "transparent", display: "flex", justifyContent: "center" }}>
                    <ul style={{
                      width: "80%", height: "95%", display: "flex", flexDirection: "column", color: "gray", overflowY: "auto",
                      backgroundColor: "transparent",
                      borderRadius: "15px",
                      marginLeft: "-8%"
                    }}>
                      {!data.fields ? (<p>Loading</p>) : filterdata.map(item =>

                        <>

                          <div style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
                            <div style={{ width: "30%", alignItems: "center", justifyContent: "center", display: "flex" }}><p>{item.key}</p></div>
                            <div style={{ width: "30%", alignItems: "center", justifyContent: "center", display: "flex" }}><p>{item.value}</p></div>
                          </div>
                          <div style={{ width: "85%", height: "5px", color: "black" }}></div>
                        </>
                      )}

                    </ul>


                  </div>
                </div>

              </div>
            </div>

            <div style={{
              display: "flex",
              backgroundColor: "white",
              height: "89%",
              width: "53%",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "15px",
              borderRadius: "15px",
              marginLeft: "1%"
            }}>
              <div style={{ backgroundColor: "transparent", width: "100%", height: "13%", alignItems: "center", color: "gray", fontSize: "16px", flexDirection: "row", display: "flex" }}>
                <h1 style={{ marginLeft: "2.4%" }}>Aktive Regionalgruppen</h1>
              </div>
              <div style={{ width: "98%", height: "1px", backgroundColor: "gray" }}></div>
              {
                reglist && reglist.map((item)=> {
                  return (<Typography sx={{mt: 1}}>{item.name}</Typography>)
                })
              }

            </div>




          </div>


        </ul>




      </div>


      <div><NavigationBar state={"verein"} back={true} /></div>
      <Sidebar />
      {edit && (
        <>
          <div style={{
            position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", backgroundColor: "white", display: "flex",
            width: "50%",
            height: "60%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <div style={{ color: "white", height: "10%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "20px" }}>
              <p>Vereinsfelder</p>
            </div>
            <div style={{ flexDirection: "row", width: "100%", height: "10%", backgroundColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <p>Vereinsname:</p>
              <input type="text" placeholder={data.Vereinsname} onChange={(e) => setvereinsname(e.target.value == "" ? setvereinsname(data.Vereinsname) : e.target.value)} />
            </div>
            <div style={{ width: "90%", height: "70%", display: "flex", flexDirection: "row", backgroundColor: "#e4e2e2", borderColor: "gray", borderWidth: "1px", borderStyle: "solid" }}>
              <div style={{ width: "100%", backgroundColor: "transparent", height: "10%", borderStyle: "solid", borderColor: "gray", borderWidth: "1px" }}>
                <div style={{ width: "100%", color: "black", display: "flex", height: "100%", alignItems: "center", marginLeft: "1%", fontSize: "20px", justifyContent: "space-between" }}>
                  <p>Feldbezeichnung:</p>
                  <p>Wert:</p>
                  <p style={{ marginRight: "5%" }}>Bearbeiten:</p>
                </div>
                <ul style={{ width: "95%", height: "350px", backgroundColor: "transparent", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                  {
                    data.fields.map(item =>
                      <>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                          <div style={{ width: "30%" }}><p>{item.key}</p></div>
                          <div style={{ width: "30%", display: "flex", justifyContent: "center" }}><p>{item.value}</p></div>
                          <div style={{ width: "30%", justifyContent: "flex-end", display: "flex" }}><div style={{ marginRight: "25%" }} onClick={(e) => { handleClick(e); setcurrent(item.key) }}><TuneOutlinedIcon></TuneOutlinedIcon></div></div>
                        </div>

                      </>
                    )

                  }
                </ul>

              </div>

            </div>
            <div style={{ width: "100%", justifyContent: "space-evenly", display: "flex", marginTop: "1%" }}>
              <div onClick={() => {
                setedit(false);
                if (vereinsname != null && vereinsname != "" && vereinsname != data.Vereinsname) {
                  editname(vereinsname);
                }

              }}><Stylebutton buttonText={"Schließen"} /></div>
              <div onClick={() => setcreateform(true)}><Stylebutton buttonText={"Erstellen"} /></div>
            </div>
          </div>
        </>
      )}
      {
        createform && (
          <div style={{
            position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", backgroundColor: "white", display: "flex",
            width: "40%",
            height: "30%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <div style={{ color: "white", height: "15%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "20px" }}>
              <p>Vereinsfeld Erstellen</p>
            </div>
            <div style={{ width: "100%", backgroundColor: "transparent", height: "65%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
              <input
                type="text"
                placeholder="Feldbezeichnung"
                style={{
                  backgroundColor: '#fff',     // dunkler Hintergrund
                  color: 'black',               // weißer Text innen
                  border: '1px solid #3a3f54',    // dezente Umrandung
                  borderRadius: '8px',            // abgerundete Ecken
                  padding: '12px 16px',           // Innenabstand
                  fontSize: '16px',
                  outline: 'none',
                  width: '30%',
                  maxWidth: '400px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                  transition: 'border-color 0.3s ease',
                  placeholder: {
                    color: 'gray',             // heller Placeholder
                  }
                }}
                onFocus={(e) => e.target.style.borderColor = '#4f5b77'}
                onBlur={(e) => e.target.style.borderColor = '#3a3f54'}
                id="funktionsbezeichnung-create"
              />
              <input
                type="text"
                placeholder="Wert"
                id="funktionswert-create"
                style={{
                  backgroundColor: '#fff',     // dunkler Hintergrund
                  color: 'black',               // weißer Text innen
                  border: '1px solid #3a3f54',    // dezente Umrandung
                  borderRadius: '8px',            // abgerundete Ecken
                  padding: '12px 16px',           // Innenabstand
                  fontSize: '16px',
                  outline: 'none',
                  width: '30%',
                  maxWidth: '400px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                  transition: 'border-color 0.3s ease',
                  placeholder: {
                    color: 'gray',             // heller Placeholder
                  }
                }}
                onFocus={(e) => e.target.style.borderColor = '#4f5b77'}
                onBlur={(e) => e.target.style.borderColor = '#3a3f54'}
              />



            </div>
            <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
              <div onClick={() => {
                setcreateform(false)



              }}><Stylebutton buttonText={"Abbrechen"}></Stylebutton></div>
              <div onClick={() => {
                if (document.getElementById("funktionsbezeichnung-create").value != "" &&
                  document.getElementById("funktionswert-create").value != ""
                ) {
                  addfiled(document.getElementById("funktionsbezeichnung-create").value, document.getElementById("funktionswert-create").value);
                  setcreateform(false);
                }


              }}><Stylebutton buttonText={"Speichern"}></Stylebutton></div>
            </div>

          </div>


        )
      }
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: mousePos.y,
            left: mousePos.x,
            backgroundColor: 'white',
            width: '160px',
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
            borderStyle: 'solid',
            borderColor: 'gray',
            borderWidth: '1px',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1000,
          }}
        >


          {/* Löschen */}
          <div
            onClick={() => removefield(current)}
            style={{
              height: '45px',
              backgroundColor: false ? '#f0f0f0' : 'transparent',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              color: "red",
              cursor: 'pointer',
            }}
          >
            <DeleteOutlineOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
            <p style={{ margin: 0 }}>Löschen</p>
          </div>




        </div>

      )}

    </>
  );
}
export default Veranstatungallgemein;